const initialState = {
  loading: false,
  movie: [],
  error: "",
};

const searchReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case "SEARCH_FETCH_REQUEST":
      return {
        loading: true,
      };

    case "SEARCH_FETCH_SUCCESS":
      return {
        loading: false,
        movie: payload,
      };

    case "SEARCH_FETCH_FAILURE":
      return {
        loading: false,
        error: payload,
      };

    default:
      return state;
  }
};

export default searchReducer;
